import * as React from 'react';
import { Skeleton, useTheme, styled, Grid, Box } from '@mui/material';
import Row from '../../../Row';
import Column from '../../../Row';

const PaddedBottomRow = styled(Row)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
}));

const VerticalBarChartSkeleton = () => {
  const theme = useTheme();

  return (
    <Box component="div" style={{ padding: `0px ${theme.spacing(3)}` }}>
      {[...Array(35)].map((_ignored, k) => (
        <React.Fragment key={k}>
          <PaddedBottomRow centered hAlign="flex-start">
            <Column grow>
              <Grid
                style={{
                  marginBottom: theme.spacing(2),
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Skeleton
                  data-testid="printed-vertical-bar-chart-skeleton"
                  variant="rectangular"
                  width={28}
                  height={28}
                  style={{ marginRight: theme.spacing(1.5) }}
                />
              </Grid>
              <Skeleton variant="rectangular" height={12} width="100%" style={{ marginTop: theme.spacing(1) }} />
            </Column>
          </PaddedBottomRow>
        </React.Fragment>
      ))}
    </Box>
  );
};
export default VerticalBarChartSkeleton;
